import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const user = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    email: z.string().describe('Email - User email address'),

    roleAssignments: hasMany('RoleAssignment'),

    personalAccessTokens: hasMany('PersonalAccessToken'),

    createdMeasurementSets: hasMany('MeasurementSet', 'createdById'),
  })
  .describe('Authenticated user identified by email address.')
  .as('User');

export { user as userSchema };
